import React from "react"

// customerValue and boatSummary return null when empty so the ident cell
// falls back to its usual em dash placeholder.

export const customerValue = ({ contactName, contactPhone, contactEmail }) => {
  if (!contactName && !contactPhone && !contactEmail) return null

  return (
    <>
      {contactName && <div>{contactName}</div>}
      {contactPhone && <div className="font-medium">{contactPhone}</div>}
      {contactEmail && <div className="font-medium">{contactEmail}</div>}
    </>
  )
}

export const boatSummary = (contactBoat, boatLengthFormatted) =>
  [contactBoat?.name, boatLengthFormatted].filter(Boolean).join(", ") || null

// An explicit label instead of the em dash, so a missing assignment can't pass for a field that failed to load.
export const locationValue = (spaceName) => spaceName || "No assignment"
